import React, { forwardRef } from 'react'
import { SErrorText, SRadioCircle, SRadioContainer, SRadioInput } from './Radio.styled'
import { Stack } from 'components/Stack'

export type RadioProps = React.HTMLProps<Pick<HTMLInputElement, 'type'>> & {
  children?: React.ReactNode
  error?: string
  hideErrorTip?: boolean
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ children, className, error, hideErrorTip, ...inputProps }, ref) => {
    return (
      <Stack space={0} className={className}>
        <SRadioContainer isReadOnly={inputProps.readOnly || inputProps.disabled}>
          <SRadioInput {...inputProps} type="radio" ref={ref} as="input" />
          <SRadioCircle invalid={!!error} />
          {children}
        </SRadioContainer>
        {!hideErrorTip && error && <SErrorText>{error}</SErrorText>}
      </Stack>
    )
  }
)
Radio.displayName = 'Radio'
